export const PHONE_VALIDATE = {
  REGEX: /^\d*$/,
  ERROR_MESSAGE: "Số điện thoại không hợp lệ",
  START_WITH_ZERO: {
    LENGTH: 10,
    ERROR_MESSAGE: "Số điện thoại phải có 10 số",
  },
  START_WITH_02: {
    MIN: 10,
    MAX: 11,
    ERROR_MESSAGE: "Số điện thoại bàn phải từ 10 đến 11 số",
  },
  OTHER: {
    MIN: 7,
    MAX: 11,
    MIN_ERROR: "Số điện thoại phải có ít nhất 7 số",
    MAX_ERROR: "Số điện thoại không được quá 11 số",
  },
};

export const getPhoneValidation = t => {
  return {
    regex: PHONE_VALIDATE.REGEX,
    errorMessage: PHONE_VALIDATE.ERROR_MESSAGE,
    when: (phone_number, yupNext) => {
      if (phone_number && phone_number.substring(0, 2) === "02") {
        return yupNext
          .min(
            PHONE_VALIDATE.START_WITH_02.MIN,
            PHONE_VALIDATE.START_WITH_02.ERROR_MESSAGE
          )
          .max(
            PHONE_VALIDATE.START_WITH_02.MAX,
            PHONE_VALIDATE.START_WITH_02.ERROR_MESSAGE
          );
      } else if (phone_number && phone_number.substring(0, 1) === "0") {
        return yupNext.length(
          PHONE_VALIDATE.START_WITH_ZERO.LENGTH,
          PHONE_VALIDATE.START_WITH_ZERO.ERROR_MESSAGE
        );
      } else if (phone_number) {
        return yupNext
          .min(PHONE_VALIDATE.OTHER.MIN, PHONE_VALIDATE.OTHER.MIN_ERROR)
          .max(PHONE_VALIDATE.OTHER.MAX, PHONE_VALIDATE.OTHER.MAX_ERROR);
      }
      return yupNext;
    },
  };
};
